import React, {useEffect, useState} from 'react';
import Icon from "./Icon";

export const onlineColor = '#2ED47A';
export const offlineColor = '#F7685B';
export const inProgressColor = '#109CF1';
export const pendingTransactionColor = 'orange';

export const getColor = (isOnline, transactionTarget) => {
  if (isOnline && transactionTarget) {
    return inProgressColor;
  }

  if (!isOnline && !transactionTarget) {
    return offlineColor;
  }

  if (isOnline && !transactionTarget) {
    return onlineColor;
  }

  if (!isOnline && transactionTarget) {
    return pendingTransactionColor;
  }
}

export const PortalWifiIcon = ({prefixIcon, isOnline = false, transactionTarget}) => {

  const [color, setColor] = useState(offlineColor);

  useEffect(() => {
    setColor(getColor(isOnline, transactionTarget));
  }, [isOnline, transactionTarget])

  return <Icon icon={prefixIcon} style={{color}}/>

}



// WEBPACK FOOTER //
// ./src/component/Icon/WifiIcon.js